import { render } from "./LocalLogin.vue?vue&type=template&id=f67b9ac8"
import script from "./LocalLogin.vue?vue&type=script&lang=js"
export * from "./LocalLogin.vue?vue&type=script&lang=js"

import "./LocalLogin.vue?vue&type=style&index=0&id=f67b9ac8&lang=scss&scope=true"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__